import QuestionnairesTable from './QuestionnairesTable';

export default QuestionnairesTable;
